import React, { Dispatch, SetStateAction } from 'react'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '../../../components/LoadingSpinner'

interface ConfirmationModalParams {
  loading: boolean
  title: string
  modalBody: React.ReactNode
  isConfirmationModalOpen: boolean
  setIsConfirmationModalOpen: Dispatch<SetStateAction<boolean>>
  submissionConfirmed: () => void
}

function ConfirmationModal({
  loading,
  title,
  modalBody,
  isConfirmationModalOpen,
  setIsConfirmationModalOpen,
  submissionConfirmed,
}: ConfirmationModalParams) {
  const { t } = useTranslation()

  return (
    <Modal
      show={isConfirmationModalOpen}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      onHide={() => setIsConfirmationModalOpen(false)}
      animation={false}
      centered
    >
      <Modal.Header>
        <Modal.Title>
          <h2 className="text-capitalize">{title}</h2>
          <button
            type="button"
            className="btn btn-link no-underline btn-lg d-flex justify-content-center align-items-center px-0"
            onClick={() => setIsConfirmationModalOpen(false)}
          >
            <span>{t('buttons.close')}</span>
            <i className="fal fa-times fa-2x ms-2" />
          </button>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {modalBody}
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          disabled={loading}
          className="btn btn-dark btn-lg m-0 text-primary"
          onClick={() => submissionConfirmed()}
        >
          {loading ? <LoadingSpinner /> : <span>{t('buttons.submit')}</span>}
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default ConfirmationModal
